import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { CurrencyMaskConfig, CurrencyMaskInputMode } from 'ngx-currency';

@Component({
  selector: 'app-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputCurrencyComponent,
      multi: true
    }
  ]
})
export class InputCurrencyComponent implements ControlValueAccessor {
  @Input() formControl: FormControl;
  @Input() options: Partial<CurrencyMaskConfig> = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    align: 'left',
    inputMode: CurrencyMaskInputMode.NATURAL
  };
  @Input() label: string;
  @Input() placeholder: string;
  @Input() hint: string;
  @Input() showValidations = false;
  @Input() required: boolean;
  @Input() readonly: boolean;

  @Input()
  @HostBinding('class.mark-required')
  markRequired: boolean;

  value = '';

  @Output() enterPress = new EventEmitter<string>();

  private onChangeCallback: (_: any) => {};
  private onTouchedCallback: (_: any) => {};

  constructor() {
  }

  onChange(event: any) {
    this.value = event.target.value;

    if (this.formControl) {
      return;
    }

    if (this.onChangeCallback) {
      this.onChangeCallback(this.value);
    }
    if (this.onTouchedCallback) {
      this.onTouchedCallback(this.value);
    }
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  onEnterPress(): void {
    this.enterPress.emit(this.value);
  }
}
